import { Flex, Label } from 'shared/ui'
import { Checkbox } from 'util/ui'

import ActionAccessWarning from '../../shared/ActionAccessWarning'
import {
  CheckboxColumn,
  LabelColumn,
  SettingRow,
  Tabs,
} from '../../shared/SettingsModal'

const rows = [
  {
    label: 'Issue has been created',
    reopen: 'reopenOn.issueCreated',
    show: 'showAction.issueCreated',
  },
  {
    label: 'Issue has been updated',
    reopen: 'reopenOn.issueUpdated',
    show: 'showAction.issueUpdated',
  },
  {
    label: 'Issue has been removed',
    reopen: 'reopenOn.issueRemoved',
    show: 'showAction.issueRemoved',
  },
  {
    label: 'Issue status has changed',
    reopen: 'reopenOn.issueStatusChanged',
    show: 'showAction.issueStatusChanged',
  },
]

export default function LinearSettingsForm({ formFields, onChange }) {
  return (
    <Tabs.Content active>
      <p>
        Set actions to <strong>Re-open</strong> again if {app.t('a_ticket')} has
        been closed and/or <strong>Show</strong> actions in the conversation
        view.
      </p>

      <ActionAccessWarning />

      <Flex>
        <LabelColumn>
          <Label as="h4">&nbsp;</Label>
          {rows.map(({ label }) => (
            <SettingRow key={label}>{label}</SettingRow>
          ))}
        </LabelColumn>

        <CheckboxColumn>
          <Label as="h4">Re-open</Label>
          {rows.map(({ label, reopen }) => (
            <SettingRow key={reopen}>
              <Checkbox
                aria-label={`Re-open: ${label}`}
                checked={!!formFields[reopen]}
                name={reopen}
                onChange={onChange}
              />
            </SettingRow>
          ))}
        </CheckboxColumn>

        <CheckboxColumn>
          <Label as="h4">Show</Label>
          {rows.map(({ label, show }) => (
            <SettingRow key={show}>
              <Checkbox
                aria-label={`Show: ${label}`}
                checked={!!formFields[show]}
                name={show}
                onChange={onChange}
              />
            </SettingRow>
          ))}
        </CheckboxColumn>
      </Flex>
    </Tabs.Content>
  )
}
